import { parsePhoneNumber } from 'libphonenumber-js';

// formats a phone number in e164 format, if possible. example: +15551230987
// the defaultCountryIso parameter helps the lib to guess the number nationality
// for inputs in non-standard format.
export const e164PhoneFormatter = (value, defaultCountryIso) => {
  if (!value) return '';

  try {
    const parsedNum = parsePhoneNumber(value, defaultCountryIso);
    if (!parsedNum.isValid()) return value;
    return parsedNum.number;
  } catch (_error) {
    // invalid number or country
    return value;
  }
};

// formats a phone number in the national, friendly format, if possible.
// e.g. (555) 123-0987 for US, 020 7407 0557 for London
export const nationalPhoneFormatter = value => {
  if (!value) return '';

  try {
    return parsePhoneNumber(value).formatNational();
  } catch (_error) {
    return value;
  }
};
